import type { ReactNode } from 'react'
import { Outlet } from 'react-router'
import { ErrorBox } from '@/components/commons/error-box'
import { Container } from '@/components/ui/container'
import { AlertTriangleIcon } from '@/components/ui/icons'
import { ErrorBoundary } from '@/error-boundary'
import { ExpVettingHeaderEndSlot } from '@/features/experience-vetting/components/exp-vetting-header-end-slot.tsx'
import { useGetExperienceVetting } from '@/features/experience-vetting/queries/use-get-experience-vetting.ts'
import { OpsVettingHeader } from '@/features/ops-vetting/components/ops-vetting-header'
import { OpsVettingURLParams } from '@/features/ops-vetting/types'
import { useURLParsedParams } from '@/hooks/use-url-parsed-params'
import { ExperienceVettingSteps } from '@/routes'
import { useTranslation } from '@/translations/i18n'

export const ExperienceVetting = () => {
	const { t } = useTranslation()
	const urlParams = useURLParsedParams(OpsVettingURLParams)

	return urlParams.success ? (
		<OpsVettingDataInitializer experienceId={urlParams.data.id}>
			<ErrorBoundary>
				<div className='grid h-full grid-cols-[minmax(0,1fr)] grid-rows-[auto_minmax(0,1fr)] overflow-hidden'>
					<Container fullWidth>
						<OpsVettingHeader
							endSlot={
								<ExpVettingHeaderEndSlot
									experienceId={urlParams.data.id}
								/>
							}
							steps={ExperienceVettingSteps}
							title={t('vetting:experience_vetting')}
							vettingId={urlParams.data.id}
						/>
					</Container>
					<Outlet context={{ urlParams: urlParams.data }} />
				</div>
			</ErrorBoundary>
		</OpsVettingDataInitializer>
	) : (
		<ErrorBox
			icon={<AlertTriangleIcon />}
			title={t('errors:invalid_url')}
		/>
	)
}

export const OpsVettingDataInitializer = ({
	experienceId,
	children
}: {
	experienceId: OpsVettingURLParams['id']
	children: ReactNode
}) => {
	useGetExperienceVetting(experienceId)
	return children
}
